webpackJsonp([0],{

/***/ 528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_home_vue__ = __webpack_require__(535);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70d4c0e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_home_vue__ = __webpack_require__(586);
var normalizeComponent = __webpack_require__(79)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70d4c0e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_home_banner__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_component_our_products__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_component_our_team__ = __webpack_require__(582);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function onResize() {
	this.windowSize = { x: window.innerWidth, y: window.innerHeight };
}

function data() {
	return {
		links: [{
			id: 1,
			name: 'facebook',
			link: 'https://es-la.facebook.com/apprunn/',
			icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/facebook+(1).svg',
			width: 15
		}, {
			id: 2,
			name: 'instagram',
			link: 'https://www.instagram.com/apprunn/?igshid=1qlz6flo9sst4',
			icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/instagram-sketched.svg',
			width: 19
		}, {
			id: 3,
			name: 'linkedin',
			icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/linkedin+(1).svg',
			link: 'https://www.linkedin.com/company/apprunn',
			width: 19
		}, {
			id: 4,
			name: 'youtube',
			link: 'https://www.youtube.com/channel/UCXfyVSRRJbBL1bUGbRqJCSA?disable_polymer=true&nv=1',
			width: 14,
			icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/play+(2).svg'
		}],
		logosCompany: [{
			id: 1,
			name: 'gittrack',
			icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/gittrack.svg',
			widthDesktop: '170px',
			widthMobile: '125px'
		}, {
			id: 2,
			name: 'japisale',
			icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/japisale.svg',
			widthDesktop: '170px',
			widthMobile: '94px'
		}, {
			id: 3,
			name: 'quipu',
			icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/quipu.svg',
			widthDesktop: '170px',
			widthMobile: '92px'
		}, {
			id: 4,
			name: 'controlinn',
			icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/controlinn.svg',
			widthMobile: '133px'
		}, {
			id: 5,
			name: 'smart360',
			icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/smart.svg',
			widthDesktop: '170px',
			widthMobile: '123px'
		}, {
			id: 6,
			name: 'perudatos',
			icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/perudatos.svg',
			widthDesktop: '170px',
			widthMobile: '149px'
		}, {
			id: 7,
			name: 'feedBackinn',
			icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/feedbackinn.svg',
			widthDesktop: '170px',
			widthMobile: '142px'
		}],
		collaborators: [{
			id: 1,
			name: 'Marcelo Carranza',
			carge: '',
			image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/marcelo-min-1.png',
			imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/marcelo-min-color.png'
		}, {
			id: 2,
			name: 'Jorge',
			image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/jorge-min-1.png',
			imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/jorge-min-color.png',
			carge: ''
		}, {
			id: 3,
			name: 'ERIC SILVA',
			carge: '',
			image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/eric-min-1.png',
			imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/eric-min-color.png'
		}, {
			id: 3,
			name: 'WENDY APAZA',
			carge: '',
			image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/wendy-min-1.png',
			imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/wendy-min-color.png'
		}, {
			id: 4,
			name: 'ARELIS CHICCHON',
			carge: '',
			image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/arelis-min-1.png',
			imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/arelis-min-color.png'
		}, {
			id: 5,
			name: 'JOSÉ JUAN DOMINGUEZ',
			carge: '',
			image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/jose-juan-min-1.png',
			imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/jose-juan-min-color.png'
		}, {
			id: 6,
			name: 'LUIS BOLIVAR',
			carge: '',
			image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/luis-min-1.png',
			imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/luis-min-color.png'
		}, {
			id: 7,
			name: 'JHONN AYALA',
			carge: '',
			image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/jhonn-min-1.png',
			imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/jhonn-min-color.png'
		}, {
			id: 8,
			name: 'CELSO ESPINOZA',
			carge: '',
			image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/celso-min-1.png',
			imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/celso-min-color.png'
		}, {
			id: 9,
			name: 'XAVIER DÁVILA',
			carge: '',
			image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/xavier-min-1.png',
			imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/xavier-min-color.png'
		}, {
			id: 10,
			name: 'ANTHONY DÁVILA',
			carge: '',
			image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/anthony-min-1.png',
			imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/anthony-min.png'
		}, {
			id: 11,
			name: 'ELENA JAPA',
			carge: '',
			image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/elena-min-1.png',
			imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/elena-min-color.png'
		}, {
			id: 12,
			name: 'AIROM VERGARA',
			carge: '',
			image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/airom-min-1.png',
			imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/airom-min-color.png'
		}, {
			id: 11,
			name: 'BRAYAN SANCHEZ',
			carge: '',
			image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/brayan-min-1.png',
			imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/brayan-min-color.png'
		}, {
			id: 12,
			name: 'ANGELA QUISPE',
			carge: '',
			image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/angela-min-1.png',
			imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/angela-min-color.png'
		}, {
			id: 13,
			name: 'IESUS ALEGRE',
			carge: '',
			image: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/iesus-min-1.png',
			imageColor: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/iesus-color.png'
		}],
		windowSize: {
			x: 0,
			y: 0
		}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-home',
	data: data,
	components: {
		banner: __WEBPACK_IMPORTED_MODULE_0__components_home_banner__["a" /* default */],
		componentOurProducts: __WEBPACK_IMPORTED_MODULE_1__components_home_component_our_products__["a" /* default */],
		componentOurTeam: __WEBPACK_IMPORTED_MODULE_2__components_home_component_our_team__["a" /* default */]
	},
	methods: {
		onResize: onResize
	}
});

/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_home_component_description__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_home_component_icon_networks__ = __webpack_require__(569);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function onScroll() {
	this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;
}

function onResize() {
	this.windowSize = { x: window.innerWidth, y: window.innerHeight };
}

function data() {
	return {
		logoApprunn: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/logo-apprunn.svg',
		offsetTop: 0,
		windowSize: {
			x: 0,
			y: 0
		}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'banner',
	data: data,
	components: {
		componentDescription: __WEBPACK_IMPORTED_MODULE_0__components_home_component_description__["a" /* default */],
		componentIconNetworks: __WEBPACK_IMPORTED_MODULE_1__components_home_component_icon_networks__["a" /* default */]
	},
	methods: {
		onScroll: onScroll,
		onResize: onResize
	},
	props: {
		links: {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	}
});

/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'component-description'
});

/***/ }),

/***/ 538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'component-icon-networks',
	props: {
		links: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		offsetTop: [String, Number],
		windowSize: {
			default: function _default() {},
			type: Object
		}
	}
});

/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_home_logo_company__ = __webpack_require__(577);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'component-our-products',
	props: {
		logosCompany: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		windowSize: {
			default: function _default() {},
			type: Object
		}
	},
	components: {
		logoCompany: __WEBPACK_IMPORTED_MODULE_0__components_home_logo_company__["a" /* default */]
	}
});

/***/ }),

/***/ 540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'logo-company',
	props: {
		logosCompany: {
			type: Array,
			default: function _default() {
				return [];
			}
		},
		windowSize: {
			default: function _default() {},
			type: Object
		}
	}
});

/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'component-our-team',
	props: {
		collaborators: {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	}
});

/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_banner_vue__ = __webpack_require__(536);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ee4d0ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_banner_vue__ = __webpack_require__(573);
function injectStyle (ssrContext) {
  __webpack_require__(563)
}
var normalizeComponent = __webpack_require__(79)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ee4d0ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_banner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ee4d0ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_banner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(564);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(526)("cc24092e", content, true);

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(525)(true);
// imports


// module
exports.push([module.i, ".banner[data-v-6ee4d0ce]{background-image:url(\"https://web-apprunn.s3-sa-east-1.amazonaws.com/cyber-armis+(1).png\");background-position:50%;background-repeat:no-repeat;background-size:cover;height:100vh;padding-top:127px;position:relative;width:100%;z-index:2}@media (max-width:1024px){.banner[data-v-6ee4d0ce]{padding:64px 50px;height:850px}}.description-banner[data-v-6ee4d0ce]{font-family:Lato,sans-serif;font-weight:900;font-size:16px;margin:66px auto 92px;max-width:440px}@media (max-width:1024px){.description-banner[data-v-6ee4d0ce]{margin-top:40px auto 59px auto}}.title-light-blue[data-v-6ee4d0ce]{color:#41c8ce;font-family:Lato,sans-serif;font-weight:900}@media (max-width:1024px){.title-light-blue[data-v-6ee4d0ce]{font-size:24px;margin:0}}@media (max-width:1024px){.text-white[data-v-6ee4d0ce]{font-size:24px}}.border-bottom[data-v-6ee4d0ce]{border-bottom:1px solid #fff}.content-white[data-v-6ee4d0ce]{font-family:Lato,sans-serif;font-weight:900;font-size:14px}@media (max-width:1024px){.content-white[data-v-6ee4d0ce]{margin-top:25px;text-align:center!important}}@media (max-width:1024px){.responsive-column[data-v-6ee4d0ce]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}@media (min-width:1024px){.max-width[data-v-6ee4d0ce]{margin:0 0 0 25px;max-width:338px}}.font-size[data-v-6ee4d0ce]{font-size:56px}@media (max-width:1024px){.font-size[data-v-6ee4d0ce]{font-size:24px}}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/banner.vue"],"names":[],"mappings":"AACA,yBACE,2FAA4F,AAC5F,wBAA4B,AAC5B,4BAA6B,AAC7B,sBAAuB,AACvB,aAAc,AACd,kBAAmB,AACnB,kBAAmB,AACnB,WAAY,AACZ,SAAW,CACZ,AACD,0BACA,yBACM,kBAAmB,AACnB,YAAc,CACnB,CACA,AACD,qCACE,4BAAgC,AAChC,gBAAiB,AACjB,eAAgB,AAChB,sBAA4B,AAC5B,eAAiB,CAClB,AACD,0BACA,qCACM,8BAAgC,CACrC,CACA,AACD,mCACE,cAAe,AACf,4BAAgC,AAChC,eAAiB,CAClB,AACD,0BACA,mCACM,eAAgB,AAChB,QAAU,CACf,CACA,AACD,0BACA,6BACI,cAAgB,CACnB,CACA,AACD,gCACE,4BAAiC,CAClC,AACD,gCACE,4BAAgC,AAChC,gBAAiB,AACjB,cAAgB,CACjB,AACD,0BACA,gCACM,gBAAiB,AACjB,2BAA8B,CACnC,CACA,AACD,0BACA,oCACI,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAClC,CACA,AACD,0BACA,4BACI,kBAAmB,AACnB,eAAiB,CACpB,CACA,AACD,4BACE,cAAgB,CACjB,AACD,0BACA,4BACM,cAAgB,CACrB,CACA","file":"banner.vue","sourcesContent":["\n.banner[data-v-6ee4d0ce] {\n  background-image: url(\"https://web-apprunn.s3-sa-east-1.amazonaws.com/cyber-armis+(1).png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100vh;\n  padding-top: 127px;\n  position: relative;\n  width: 100%;\n  z-index: 2;\n}\n@media (max-width: 1024px) {\n.banner[data-v-6ee4d0ce] {\n      padding: 64px 50px;\n      height: 850px;\n}\n}\n.description-banner[data-v-6ee4d0ce] {\n  font-family: 'Lato', sans-serif;\n  font-weight: 900;\n  font-size: 16px;\n  margin: 66px auto 92px auto;\n  max-width: 440px;\n}\n@media (max-width: 1024px) {\n.description-banner[data-v-6ee4d0ce] {\n      margin-top: 40px auto 59px auto;\n}\n}\n.title-light-blue[data-v-6ee4d0ce] {\n  color: #41c8ce;\n  font-family: 'Lato', sans-serif;\n  font-weight: 900;\n}\n@media (max-width: 1024px) {\n.title-light-blue[data-v-6ee4d0ce] {\n      font-size: 24px;\n      margin: 0;\n}\n}\n@media (max-width: 1024px) {\n.text-white[data-v-6ee4d0ce] {\n    font-size: 24px;\n}\n}\n.border-bottom[data-v-6ee4d0ce] {\n  border-bottom: 1px solid #ffffff;\n}\n.content-white[data-v-6ee4d0ce] {\n  font-family: 'Lato', sans-serif;\n  font-weight: 900;\n  font-size: 14px;\n}\n@media (max-width: 1024px) {\n.content-white[data-v-6ee4d0ce] {\n      margin-top: 25px;\n      text-align: center !important;\n}\n}\n@media (max-width: 1024px) {\n.responsive-column[data-v-6ee4d0ce] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n}\n@media (min-width: 1024px) {\n.max-width[data-v-6ee4d0ce] {\n    margin: 0 0 0 25px;\n    max-width: 338px;\n}\n}\n.font-size[data-v-6ee4d0ce] {\n  font-size: 56px;\n}\n@media (max-width: 1024px) {\n.font-size[data-v-6ee4d0ce] {\n      font-size: 24px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_description_vue__ = __webpack_require__(537);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5014da24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_component_description_vue__ = __webpack_require__(568);
function injectStyle (ssrContext) {
  __webpack_require__(566)
}
var normalizeComponent = __webpack_require__(79)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5014da24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_description_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5014da24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_component_description_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(567);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(526)("610eed3c", content, true);

/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(525)(true);
// imports


// module
exports.push([module.i, ".section-description[data-v-5014da24]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#fff;border-radius:30px;bottom:-60px;-webkit-box-shadow:0 2px 30px 0 rgba(0,0,0,.06);box-shadow:0 2px 30px 0 rgba(0,0,0,.06);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);margin:0 auto;padding:35px 100px;position:absolute;width:85%;z-index:4}@media (max-width:1024px){.section-description[data-v-5014da24]{bottom:-114px;-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;padding:46px 30px;width:92%}}@media (max-width:380px){.section-description[data-v-5014da24]{height:310px;top:600px}}.max-width[data-v-5014da24]{color:#919191;font-family:Lato,sans-serif;font-weight:400;font-size:16px;line-height:1.81;max-width:580px}@media (max-width:1024px){.max-width[data-v-5014da24]{text-align:center!important}}.title-company[data-v-5014da24]{color:#41c8ce;font-family:Lato,sans-serif;font-weight:700;font-size:40px;margin-left:30px}@media (max-width:1024px){.title-company[data-v-5014da24]{font-size:24px;margin:0}}.divider-description[data-v-5014da24]{background-color:#e0e0e0;height:156px;margin-left:54px;width:2px}@media (max-width:1024px){.divider-description[data-v-5014da24]{display:none}}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/component-description.vue"],"names":[],"mappings":"AACA,sCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,sBAA0B,AAC1B,mBAAoB,AACpB,aAAc,AACd,gDAAqD,AAC7C,wCAA6C,AACrD,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,SAAU,AACV,mCAAoC,AAC5B,2BAA4B,AACpC,cAAe,AACf,mBAAoB,AACpB,kBAAmB,AACnB,UAAW,AACX,SAAW,CACZ,AACD,0BACA,sCACM,cAAe,AACf,4BAA6B,AAC7B,8BAA+B,AAC3B,kCAAmC,AAC/B,8BAA+B,AACvC,kBAAmB,AACnB,SAAW,CAChB,CACA,AACD,yBACA,sCACM,aAAc,AACd,SAAW,CAChB,CACA,AACD,4BACE,cAAe,AACf,4BAAgC,AAChC,gBAAiB,AACjB,eAAgB,AAChB,iBAAkB,AAClB,eAAiB,CAClB,AACD,0BACA,4BACM,2BAA8B,CACnC,CACA,AACD,gCACE,cAAe,AACf,4BAAgC,AAChC,gBAAkB,AAClB,eAAgB,AAChB,gBAAkB,CACnB,AACD,0BACA,gCACM,eAAgB,AAChB,QAAU,CACf,CACA,AACD,sCACE,yBAA0B,AAC1B,aAAc,AACd,iBAAkB,AAClB,SAAW,CACZ,AACD,0BACA,sCACM,YAAc,CACnB,CACA","file":"component-description.vue","sourcesContent":["\n.section-description[data-v-5014da24] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: #ffffff;\n  border-radius: 30px;\n  bottom: -60px;\n  -webkit-box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.06);\n          box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.06);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  margin: 0 auto;\n  padding: 35px 100px;\n  position: absolute;\n  width: 85%;\n  z-index: 4;\n}\n@media (max-width: 1024px) {\n.section-description[data-v-5014da24] {\n      bottom: -114px;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: reverse;\n          -ms-flex-direction: column-reverse;\n              flex-direction: column-reverse;\n      padding: 46px 30px;\n      width: 92%;\n}\n}\n@media (max-width: 380px) {\n.section-description[data-v-5014da24] {\n      height: 310px;\n      top: 600px;\n}\n}\n.max-width[data-v-5014da24] {\n  color: #919191;\n  font-family: 'Lato', sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1.81;\n  max-width: 580px;\n}\n@media (max-width: 1024px) {\n.max-width[data-v-5014da24] {\n      text-align: center !important;\n}\n}\n.title-company[data-v-5014da24] {\n  color: #41c8ce;\n  font-family: 'Lato', sans-serif;\n  font-weight: bold;\n  font-size: 40px;\n  margin-left: 30px;\n}\n@media (max-width: 1024px) {\n.title-company[data-v-5014da24] {\n      font-size: 24px;\n      margin: 0;\n}\n}\n.divider-description[data-v-5014da24] {\n  background-color: #e0e0e0;\n  height: 156px;\n  margin-left: 54px;\n  width: 2px;\n}\n@media (max-width: 1024px) {\n.divider-description[data-v-5014da24] {\n      display: none;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 568:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-description",attrs:{"id":"description"}},[_c('div',{staticClass:"max-width "},[_vm._v("Desarrollamos productos de software , estos tienen un ciclo de vida.  Son creados para solucionar un problema en un nicho de mercado específico. "),_c('br'),_vm._v("\n \t\tEvaluamos la rentabilidad y el tamaño del  mercado")]),_vm._v(" "),_c('p',{staticClass:"divider-description"}),_vm._v(" "),_c('div',{staticClass:"title-company"},[_vm._v("\n\t\t\t Product Studio\n\t\t ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 569:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_icon_networks_vue__ = __webpack_require__(538);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cc42381_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_component_icon_networks_vue__ = __webpack_require__(572);
function injectStyle (ssrContext) {
  __webpack_require__(570)
}
var normalizeComponent = __webpack_require__(79)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7cc42381"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_icon_networks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cc42381_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_component_icon_networks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(571);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(526)("5fed522b", content, true);

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(525)(true);
// imports


// module
exports.push([module.i, ".component-networks[data-v-7cc42381]{background-color:#3bb4c1;border-bottom-left-radius:12px;border-top-left-radius:12px;padding:0 9px;position:absolute;top:114px;right:0;width:50px}.component-networks.on-scroll[data-v-7cc42381]:not(.open){-webkit-transition:all .55s ease .05s;transition:all .55s ease .05s;position:fixed;z-index:45}.component-networks.on-scrol-footer[data-v-7cc42381]:not(.open){background-color:#3bb4c1;-webkit-transition:all .55s ease .05s;transition:all .55s ease .05s;position:fixed;top:500px}@media (max-width:1024px){.component-networks.on-scrol-footer[data-v-7cc42381]:not(.open){display:none}}.component-networks.responsive-none[data-v-7cc42381]:not(.open){display:none}.border-bottom[data-v-7cc42381]{border-bottom:1px solid #fff;padding:16px 0}.border-bottom[data-v-7cc42381]:last-child{border-bottom:none!important}.link-networks[data-v-7cc42381]{cursor:pointer}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/component-icon-networks.vue"],"names":[],"mappings":"AACA,qCACE,yBAA0B,AAC1B,+BAAgC,AAChC,4BAA6B,AAC7B,cAAe,AACf,kBAAmB,AACnB,UAAW,AACX,QAAS,AACT,UAAY,CACb,AACD,0DACI,sCAAyC,AACzC,8BAAiC,AACjC,eAAgB,AAChB,UAAY,CACf,AACD,gEACI,yBAA0B,AAC1B,sCAAyC,AACzC,8BAAiC,AACjC,eAAgB,AAChB,SAAW,CACd,AACD,0BACA,gEACQ,YAAc,CACrB,CACA,AACD,gEACI,YAAc,CACjB,AACD,gCACE,6BAAiC,AACjC,cAAgB,CACjB,AACD,2CACI,4BAA+B,CAClC,AACD,gCACE,cAAgB,CACjB","file":"component-icon-networks.vue","sourcesContent":["\n.component-networks[data-v-7cc42381] {\n  background-color: #3bb4c1;\n  border-bottom-left-radius: 12px;\n  border-top-left-radius: 12px;\n  padding: 0 9px;\n  position: absolute;\n  top: 114px;\n  right: 0;\n  width: 50px;\n}\n.component-networks.on-scroll[data-v-7cc42381]:not(.open) {\n    -webkit-transition: all 0.55s 0.05s ease;\n    transition: all 0.55s 0.05s ease;\n    position: fixed;\n    z-index: 45;\n}\n.component-networks.on-scrol-footer[data-v-7cc42381]:not(.open) {\n    background-color: #3bb4c1;\n    -webkit-transition: all 0.55s 0.05s ease;\n    transition: all 0.55s 0.05s ease;\n    position: fixed;\n    top: 500px;\n}\n@media (max-width: 1024px) {\n.component-networks.on-scrol-footer[data-v-7cc42381]:not(.open) {\n        display: none;\n}\n}\n.component-networks.responsive-none[data-v-7cc42381]:not(.open) {\n    display: none;\n}\n.border-bottom[data-v-7cc42381] {\n  border-bottom: 1px solid #ffffff;\n  padding: 16px 0;\n}\n.border-bottom[data-v-7cc42381]:last-child {\n    border-bottom: none !important;\n}\n.link-networks[data-v-7cc42381] {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-networks",class:{ 'on-scroll': _vm.offsetTop > 800, 'on-scrol-footer' : _vm.offsetTop > 4090, 'responsive-none' : _vm.offsetTop > 9000}},_vm._l((_vm.links),function(item,index){return _c('v-flex',{key:index,staticClass:"border-bottom",attrs:{"text-xs-center":""}},[_c('a',{staticClass:"link-networks",attrs:{"href":item.link,"target":"_blank"}},[_c('img',{style:(("width: " + (item.width) + "px")),attrs:{"src":item.icon,"alt":""}})])])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"},{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],staticClass:"banner"},[_c('component-icon-networks',{attrs:{"offset-top":_vm.offsetTop,"window-size":_vm.windowSize,"links":_vm.links}}),_vm._v(" "),_c('v-flex',{attrs:{"text-xs-center":""}},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":_vm.logoApprunn,"alt":""}})])]),_vm._v(" "),_c('v-flex',{staticClass:"description-banner  white--text",attrs:{"text-xs-center":""}},[_vm._v("No somos una software factory, somos un product studio, es decir, \n\t\t\tdesarrollamos plataformas que solucionan problemas a diferentes sectores del mercado. \n\t\t")]),_vm._v(" "),_c('v-layout',{staticClass:"responsive-column",attrs:{"xs12":"","align-center":"","justify-center":""}},[_c('v-flex',{class:_vm.windowSize.x < 1024 ? 'xs12 text-xs-center' : 'xs6 text-xs-right'},[_c('p',{staticClass:"title-light-blue font-size"},[_vm._v(" ROMPEMOS\n\t\t\t\t\t"),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-white white--text"},[_vm._v("PARADIGMAS")])])]),_vm._v(" "),_c('v-flex',{staticClass:"white--text content-white",class:_vm.windowSize.x < 1024 ? 'xs12 text-xs-left' : 'xs6'},[_c('p',{staticClass:"max-width"},[_vm._v("\n\t\t\t\t\t\tSomos un "),_c('span',{staticClass:"border-bottom"},[_vm._v("Product Studio")]),_vm._v(" hecho en Perú, nuestra misión es crear productos que solucionen la vida de la gente sin importar donde estén y asegurándonos su crecimiento constante.\n\t\t\t\t\t")])])],1),_vm._v(" "),_c('component-description')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 574:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_our_products_vue__ = __webpack_require__(539);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f9c4ea2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_component_our_products_vue__ = __webpack_require__(581);
function injectStyle (ssrContext) {
  __webpack_require__(575)
}
var normalizeComponent = __webpack_require__(79)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f9c4ea2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_our_products_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f9c4ea2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_component_our_products_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(576);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(526)("3d55a5d5", content, true);

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(525)(true);
// imports


// module
exports.push([module.i, ".component-our-products[data-v-1f9c4ea2]{background-color:#41c8ce;padding-bottom:90px;position:relative;width:100%}@media (max-width:1024px){.component-our-products[data-v-1f9c4ea2]{height:820px;width:100%}}.name-our-products[data-v-1f9c4ea2]{color:#fff;font-family:Lato,sans-serif;font-weight:700;font-size:40px;padding:0 0 0 182px;width:600px}@media (max-width:990px){.name-our-products[data-v-1f9c4ea2]{font-size:25px;margin-bottom:50px;padding:0 46px;text-align:center;width:100%}}.content-our-products[data-v-1f9c4ea2],.triangle[data-v-1f9c4ea2]{position:relative;width:100%}.triangle[data-v-1f9c4ea2]{height:210px;background-color:#41c8ce;bottom:200px}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/component-our-products.vue"],"names":[],"mappings":"AACA,yCACE,yBAA0B,AAC1B,oBAAqB,AACrB,kBAAmB,AACnB,UAAY,CACb,AACD,0BACA,yCACM,aAAc,AACd,UAAY,CACjB,CACA,AACD,oCACE,WAAe,AACf,4BAAgC,AAChC,gBAAkB,AAClB,eAAgB,AAChB,oBAAqB,AACrB,WAAa,CACd,AACD,yBACA,oCACM,eAAgB,AAChB,mBAAoB,AACpB,eAAgB,AAChB,kBAAmB,AACnB,UAAY,CACjB,CACA,AAKD,kEAHE,kBAAmB,AACnB,UAAY,CAQb,AAND,2BACE,aAAc,AACd,yBAA0B,AAG1B,YAAc,CACf","file":"component-our-products.vue","sourcesContent":["\n.component-our-products[data-v-1f9c4ea2] {\n  background-color: #41c8ce;\n  padding-bottom: 90px;\n  position: relative;\n  width: 100%;\n}\n@media (max-width: 1024px) {\n.component-our-products[data-v-1f9c4ea2] {\n      height: 820px;\n      width: 100%;\n}\n}\n.name-our-products[data-v-1f9c4ea2] {\n  color: #ffffff;\n  font-family: 'Lato', sans-serif;\n  font-weight: bold;\n  font-size: 40px;\n  padding: 0 0 0 182px;\n  width: 600px;\n}\n@media (max-width: 990px) {\n.name-our-products[data-v-1f9c4ea2] {\n      font-size: 25px;\n      margin-bottom: 50px;\n      padding: 0 46px;\n      text-align: center;\n      width: 100%;\n}\n}\n.content-our-products[data-v-1f9c4ea2] {\n  position: relative;\n  width: 100%;\n}\n.triangle[data-v-1f9c4ea2] {\n  height: 210px;\n  background-color: #41c8ce;\n  width: 100%;\n  position: relative;\n  bottom: 200px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 577:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logo_company_vue__ = __webpack_require__(540);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_063ad2f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logo_company_vue__ = __webpack_require__(580);
function injectStyle (ssrContext) {
  __webpack_require__(578)
}
var normalizeComponent = __webpack_require__(79)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-063ad2f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logo_company_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_063ad2f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logo_company_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(579);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(526)("28793d7a", content, true);

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(525)(true);
// imports


// module
exports.push([module.i, ".grid-our-products[data-v-063ad2f0]{align-self:center;display:grid;grid-column-gap:184px;grid-row-gap:73px;grid-template-columns:auto auto auto;margin:95px auto 0}@media (max-width:1024px){.grid-our-products[data-v-063ad2f0]{grid-column-gap:33px;grid-row-gap:44px;grid-template-columns:auto auto;margin:45px auto 0}}@media (max-width:380px){.grid-our-products[data-v-063ad2f0]{grid-template-columns:auto}}@media (max-width:1024px){.icon-products[data-v-063ad2f0]{width:120px}}.content-logo-company[data-v-063ad2f0]:nth-child(7){grid-column:2/3}@media (max-width:1024px){.content-logo-company[data-v-063ad2f0]:nth-child(7){grid-column:1/3;margin-left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}}.content-logo-company[data-v-063ad2f0]{opacity:.43}@media (max-width:1024px){.content-logo-company[data-v-063ad2f0]{opacity:1}}@media (min-width:1024px){.content-logo-company[data-v-063ad2f0]:hover{-webkit-transform:scale(1.05);transform:scale(1.05);-webkit-transition:all .3s ease-in-out;transition:all .3s ease-in-out;opacity:1}}.icon-products[data-v-063ad2f0]{height:65px;width:170px}@media (max-width:860px){.icon-products[data-v-063ad2f0]{width:130px}}@media (max-width:860px){.icon-responsive[data-v-063ad2f0]{width:94px}}@media (max-width:860px){.icon-feedbackin[data-v-063ad2f0]{width:142px}}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/logo-company.vue"],"names":[],"mappings":"AACA,oCACE,kBAAmB,AACnB,aAAc,AACd,sBAAuB,AACvB,kBAAmB,AACnB,qCAAsC,AACtC,kBAAyB,CAC1B,AACD,0BACA,oCACM,qBAAsB,AACtB,kBAAmB,AACnB,gCAAiC,AACjC,kBAAyB,CAC9B,CACA,AACD,yBACA,oCACM,0BAA4B,CACjC,CACA,AAKD,0BACA,gCACM,WAAa,CAClB,CACA,AACD,oDACE,eAAmB,CACpB,AACD,0BACA,oDACM,gBAAmB,AACnB,gBAAiB,AACjB,mCAAoC,AAC5B,0BAA4B,CACzC,CACA,AACD,uCACE,WAAc,CACf,AACD,0BACA,uCACM,SAAW,CAChB,CACA,AACD,0BACA,6CACM,8BAA+B,AACvB,sBAAuB,AAC/B,uCAAwC,AACxC,+BAAgC,AAChC,SAAW,CAChB,CACA,AACD,gCACE,YAAa,AACb,WAAa,CACd,AACD,yBACA,gCACM,WAAa,CAClB,CACA,AACD,yBACA,kCACI,UAAY,CACf,CACA,AACD,yBACA,kCACI,WAAa,CAChB,CACA","file":"logo-company.vue","sourcesContent":["\n.grid-our-products[data-v-063ad2f0] {\n  align-self: center;\n  display: grid;\n  grid-column-gap: 184px;\n  grid-row-gap: 73px;\n  grid-template-columns: auto auto auto;\n  margin: 95px auto 0 auto;\n}\n@media (max-width: 1024px) {\n.grid-our-products[data-v-063ad2f0] {\n      grid-column-gap: 33px;\n      grid-row-gap: 44px;\n      grid-template-columns: auto auto;\n      margin: 45px auto 0 auto;\n}\n}\n@media (max-width: 380px) {\n.grid-our-products[data-v-063ad2f0] {\n      grid-template-columns: auto;\n}\n}\n.icon-products[data-v-063ad2f0] {\n  height: 65px;\n  width: 170px;\n}\n@media (max-width: 1024px) {\n.icon-products[data-v-063ad2f0] {\n      width: 120px;\n}\n}\n.content-logo-company[data-v-063ad2f0]:nth-child(7) {\n  grid-column: 2 / 3;\n}\n@media (max-width: 1024px) {\n.content-logo-company[data-v-063ad2f0]:nth-child(7) {\n      grid-column: 1 / 3;\n      margin-left: 50%;\n      -webkit-transform: translateX(-50%);\n              transform: translateX(-50%);\n}\n}\n.content-logo-company[data-v-063ad2f0] {\n  opacity: 0.43;\n}\n@media (max-width: 1024px) {\n.content-logo-company[data-v-063ad2f0] {\n      opacity: 1;\n}\n}\n@media (min-width: 1024px) {\n.content-logo-company[data-v-063ad2f0]:hover {\n      -webkit-transform: scale(1.05);\n              transform: scale(1.05);\n      -webkit-transition: all ease-in-out .3s;\n      transition: all ease-in-out .3s;\n      opacity: 1;\n}\n}\n.icon-products[data-v-063ad2f0] {\n  height: 65px;\n  width: 170px;\n}\n@media (max-width: 860px) {\n.icon-products[data-v-063ad2f0] {\n      width: 130px;\n}\n}\n@media (max-width: 860px) {\n.icon-responsive[data-v-063ad2f0] {\n    width: 94px;\n}\n}\n@media (max-width: 860px) {\n.icon-feedbackin[data-v-063ad2f0] {\n    width: 142px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 580:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"grid-our-products",attrs:{"align-center":""}},_vm._l((_vm.logosCompany),function(item,index){return _c('v-flex',{key:index,staticClass:"content-logo-company"},[_c('img',{staticClass:"icon-products",attrs:{"src":item.icon,"alt":""}})])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 581:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-our-products",attrs:{"id":"our-products"}},[_c('div',{staticClass:"triangle"}),_vm._v(" "),_c('div',[_c('v-layout',{staticClass:"content-our-products",attrs:{"column":""}},[_c('v-flex',{staticClass:"name-our-products"},[_vm._v("Nuestro orgullo, nuestros produtos")]),_vm._v(" "),_c('logo-company',{attrs:{"window-size":_vm.windowSize,"logos-company":_vm.logosCompany}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_our_team_vue__ = __webpack_require__(541);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07568fe2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_component_our_team_vue__ = __webpack_require__(585);
function injectStyle (ssrContext) {
  __webpack_require__(583)
}
var normalizeComponent = __webpack_require__(79)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07568fe2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_component_our_team_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07568fe2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_component_our_team_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(584);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(526)("0c5a8984", content, true);

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(525)(true);
// imports


// module
exports.push([module.i, ".component-our-team[data-v-07568fe2]{padding-bottom:100px}@media (max-width:960px){.component-our-team[data-v-07568fe2]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:50px 50px 25px}}.title-our-team[data-v-07568fe2]{color:#05316a;font-family:Lato,sans-serif;font-weight:900;font-size:40px}@media (max-width:960px){.title-our-team[data-v-07568fe2]{text-align:center}}.description-our-team[data-v-07568fe2]{color:#919191;font-family:Lato,sans-serif;font-weight:400;font-size:16px;max-width:552px}@media (max-width:960px){.description-our-team[data-v-07568fe2]{text-align:center}}.border-gray[data-v-07568fe2]{background-color:#05316a;height:130px;margin:0 37px;width:2px}@media (max-width:960px){.border-gray[data-v-07568fe2]{display:none}}.name[data-v-07568fe2]{color:#41c8ce;font-family:Lato,sans-serif;font-weight:900;font-size:18px;margin:25px 0 0}.carge[data-v-07568fe2]{color:#05316a;font-family:Lato,sans-serif;font-weight:400;font-size:15px}@media (max-width:1024px){.carge[data-v-07568fe2]{display:none}}.content-colaborators[data-v-07568fe2]{display:grid;grid-column-gap:33.4px;grid-row-gap:52px;grid-template-columns:auto auto auto auto;margin:0 auto}@media (max-width:1300px){.content-colaborators[data-v-07568fe2]{grid-column-gap:8px;grid-template-columns:auto auto auto}}@media (max-width:860px){.content-colaborators[data-v-07568fe2]{grid-row-gap:5px;grid-template-columns:auto auto}}@media (max-width:450px){.content-colaborators[data-v-07568fe2]{grid-template-columns:auto}}.image-color[data-v-07568fe2]{position:absolute}@media (max-width:960px){.image-color[data-v-07568fe2]{height:221px;width:170.8px}}.image-collaborator[data-v-07568fe2]{z-index:1}.image-collaborator[data-v-07568fe2]:nth-child(16){grid-column:2/3}@media (max-width:960px){.image-collaborator[data-v-07568fe2]{height:221px;width:170.8px}}.component-team[data-v-07568fe2]{background-color:#f2f2f2;padding:98px 0;position:relative}@media (max-width:1024px){.component-team[data-v-07568fe2]{padding:0}}.content-responsive[data-v-07568fe2]{background-color:#3bb4c1;bottom:40px;color:#fff;opacity:.48;position:relative;width:100%;z-index:10}.name-carge[data-v-07568fe2]{color:#41c8ce;font-family:Lato,sans-serif;font-weight:700;font-size:18px;margin:24px 0 5px}@media (max-width:960px){.name-carge[data-v-07568fe2]{display:none}}.triangle-css[data-v-07568fe2]{background-color:#41c8ce;height:130px;position:absolute;-webkit-transform:rotate(3deg);transform:rotate(3deg);top:-75px;width:100%}@media (max-width:1024px){.triangle-css[data-v-07568fe2]{display:none}}.background-responsive[data-v-07568fe2]{background-color:#3bb4c1;bottom:36px;color:#fff;opacity:.7;padding:10px 0;position:relative;width:170px;z-index:4}@media (min-width:960px){.background-responsive[data-v-07568fe2]{display:none}}.name-collaborator-responsive[data-v-07568fe2]{font-family:Lato,sans-serif;font-weight:700;font-size:14px;margin:0;text-align:center;z-index:9}.item-collaborator:hover .image-color[data-v-07568fe2]{z-index:3}", "", {"version":3,"sources":["/opt/build/repo/src/components/home/component-our-team.vue"],"names":[],"mappings":"AACA,qCACE,oBAAsB,CACvB,AACD,yBACA,qCACM,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,sBAA6B,CAClC,CACA,AACD,iCACE,cAAe,AACf,4BAAgC,AAChC,gBAAiB,AACjB,cAAgB,CACjB,AACD,yBACA,iCACM,iBAAmB,CACxB,CACA,AACD,uCACE,cAAe,AACf,4BAAgC,AAChC,gBAAiB,AACjB,eAAgB,AAChB,eAAiB,CAClB,AACD,yBACA,uCACM,iBAAmB,CACxB,CACA,AACD,8BACE,yBAA0B,AAC1B,aAAc,AACd,cAAe,AACf,SAAW,CACZ,AACD,yBACA,8BACM,YAAc,CACnB,CACA,AACD,uBACE,cAAe,AACf,4BAAgC,AAChC,gBAAiB,AACjB,eAAgB,AAChB,eAAmB,CACpB,AACD,wBACE,cAAe,AACf,4BAAgC,AAChC,gBAAiB,AACjB,cAAgB,CACjB,AACD,0BACA,wBACM,YAAc,CACnB,CACA,AACD,uCACE,aAAc,AACd,uBAAwB,AACxB,kBAAmB,AACnB,0CAA2C,AAC3C,aAAe,CAChB,AACD,0BACA,uCACM,oBAAqB,AACrB,oCAAsC,CAC3C,CACA,AACD,yBACA,uCACM,iBAAkB,AAClB,+BAAiC,CACtC,CACA,AACD,yBACA,uCACM,0BAA4B,CACjC,CACA,AACD,8BACE,iBAAmB,CACpB,AACD,yBACA,8BACM,aAAc,AACd,aAAe,CACpB,CACA,AACD,qCACE,SAAW,CACZ,AACD,mDACI,eAAiB,CACpB,AACD,yBACA,qCACM,aAAc,AACd,aAAe,CACpB,CACA,AACD,iCACE,yBAA0B,AAC1B,eAAgB,AAChB,iBAAmB,CACpB,AACD,0BACA,iCACM,SAAW,CAChB,CACA,AACD,qCACE,yBAA0B,AAC1B,YAAa,AACb,WAAe,AACf,YAAc,AACd,kBAAmB,AACnB,WAAY,AACZ,UAAY,CACb,AACD,6BACE,cAAe,AACf,4BAAgC,AAChC,gBAAkB,AAClB,eAAgB,AAChB,iBAAqB,CACtB,AACD,yBACA,6BACM,YAAc,CACnB,CACA,AACD,+BACE,yBAA0B,AAC1B,aAAc,AACd,kBAAmB,AACnB,+BAAgC,AACxB,uBAAwB,AAChC,UAAW,AACX,UAAY,CACb,AACD,0BACA,+BACM,YAAc,CACnB,CACA,AACD,wCACE,yBAA0B,AAC1B,YAAa,AACb,WAAe,AACf,WAAc,AACd,eAAgB,AAChB,kBAAmB,AACnB,YAAa,AACb,SAAW,CACZ,AACD,yBACA,wCACM,YAAc,CACnB,CACA,AACD,+CACE,4BAAgC,AAChC,gBAAkB,AAClB,eAAgB,AAChB,SAAU,AACV,kBAAmB,AACnB,SAAW,CACZ,AACD,uDACE,SAAW,CACZ","file":"component-our-team.vue","sourcesContent":["\n.component-our-team[data-v-07568fe2] {\n  padding-bottom: 100px;\n}\n@media (max-width: 960px) {\n.component-our-team[data-v-07568fe2] {\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      padding: 50px 50px 25px 50px;\n}\n}\n.title-our-team[data-v-07568fe2] {\n  color: #05316a;\n  font-family: 'Lato', sans-serif;\n  font-weight: 900;\n  font-size: 40px;\n}\n@media (max-width: 960px) {\n.title-our-team[data-v-07568fe2] {\n      text-align: center;\n}\n}\n.description-our-team[data-v-07568fe2] {\n  color: #919191;\n  font-family: 'Lato', sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  max-width: 552px;\n}\n@media (max-width: 960px) {\n.description-our-team[data-v-07568fe2] {\n      text-align: center;\n}\n}\n.border-gray[data-v-07568fe2] {\n  background-color: #05316a;\n  height: 130px;\n  margin: 0 37px;\n  width: 2px;\n}\n@media (max-width: 960px) {\n.border-gray[data-v-07568fe2] {\n      display: none;\n}\n}\n.name[data-v-07568fe2] {\n  color: #41c8ce;\n  font-family: 'Lato', sans-serif;\n  font-weight: 900;\n  font-size: 18px;\n  margin: 25px 0 0 0;\n}\n.carge[data-v-07568fe2] {\n  color: #05316a;\n  font-family: 'Lato', sans-serif;\n  font-weight: 400;\n  font-size: 15px;\n}\n@media (max-width: 1024px) {\n.carge[data-v-07568fe2] {\n      display: none;\n}\n}\n.content-colaborators[data-v-07568fe2] {\n  display: grid;\n  grid-column-gap: 33.4px;\n  grid-row-gap: 52px;\n  grid-template-columns: auto auto auto auto;\n  margin: 0 auto;\n}\n@media (max-width: 1300px) {\n.content-colaborators[data-v-07568fe2] {\n      grid-column-gap: 8px;\n      grid-template-columns: auto auto auto;\n}\n}\n@media (max-width: 860px) {\n.content-colaborators[data-v-07568fe2] {\n      grid-row-gap: 5px;\n      grid-template-columns: auto auto;\n}\n}\n@media (max-width: 450px) {\n.content-colaborators[data-v-07568fe2] {\n      grid-template-columns: auto;\n}\n}\n.image-color[data-v-07568fe2] {\n  position: absolute;\n}\n@media (max-width: 960px) {\n.image-color[data-v-07568fe2] {\n      height: 221px;\n      width: 170.8px;\n}\n}\n.image-collaborator[data-v-07568fe2] {\n  z-index: 1;\n}\n.image-collaborator[data-v-07568fe2]:nth-child(16) {\n    grid-column: 2/3;\n}\n@media (max-width: 960px) {\n.image-collaborator[data-v-07568fe2] {\n      height: 221px;\n      width: 170.8px;\n}\n}\n.component-team[data-v-07568fe2] {\n  background-color: #f2f2f2;\n  padding: 98px 0;\n  position: relative;\n}\n@media (max-width: 1024px) {\n.component-team[data-v-07568fe2] {\n      padding: 0;\n}\n}\n.content-responsive[data-v-07568fe2] {\n  background-color: #3bb4c1;\n  bottom: 40px;\n  color: #ffffff;\n  opacity: 0.48;\n  position: relative;\n  width: 100%;\n  z-index: 10;\n}\n.name-carge[data-v-07568fe2] {\n  color: #41c8ce;\n  font-family: 'Lato', sans-serif;\n  font-weight: bold;\n  font-size: 18px;\n  margin: 24px 0 5px 0;\n}\n@media (max-width: 960px) {\n.name-carge[data-v-07568fe2] {\n      display: none;\n}\n}\n.triangle-css[data-v-07568fe2] {\n  background-color: #41c8ce;\n  height: 130px;\n  position: absolute;\n  -webkit-transform: rotate(3deg);\n          transform: rotate(3deg);\n  top: -75px;\n  width: 100%;\n}\n@media (max-width: 1024px) {\n.triangle-css[data-v-07568fe2] {\n      display: none;\n}\n}\n.background-responsive[data-v-07568fe2] {\n  background-color: #3bb4c1;\n  bottom: 36px;\n  color: #ffffff;\n  opacity: 0.70;\n  padding: 10px 0;\n  position: relative;\n  width: 170px;\n  z-index: 4;\n}\n@media (min-width: 960px) {\n.background-responsive[data-v-07568fe2] {\n      display: none;\n}\n}\n.name-collaborator-responsive[data-v-07568fe2] {\n  font-family: 'Lato', sans-serif;\n  font-weight: bold;\n  font-size: 14px;\n  margin: 0;\n  text-align: center;\n  z-index: 9;\n}\n.item-collaborator:hover .image-color[data-v-07568fe2] {\n  z-index: 3;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 585:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"component-team",attrs:{"id":"our-team","column":""}},[_c('v-flex',{staticClass:"triangle-css"}),_vm._v(" "),_c('v-layout',{staticClass:"component-our-team",attrs:{"justify-center":"","row":"","align-center":""}},[_c('p',{staticClass:"title-our-team"},[_vm._v("NUESTRO TEAM")]),_vm._v(" "),_c('p',{staticClass:"border-gray"}),_vm._v(" "),_c('p',{staticClass:"description-our-team"},[_vm._v("Desarrollamos productos de software , estos tienen un ciclo de vida.  \n\t\t\tSon creados para solucionar un problema en un nicho de mercado específico.")])]),_vm._v(" "),_c('v-layout',{staticClass:"content-colaborators"},_vm._l((_vm.collaborators),function(item,index){return _c('v-layout',{key:index,staticClass:"item-collaborator",attrs:{"column":"","align-center":""}},[_c('img',{staticClass:"image-collaborator",attrs:{"src":item.image,"alt":""}}),_vm._v(" "),_c('img',{staticClass:"image-color",attrs:{"src":item.imageColor}}),_vm._v(" "),_c('v-flex',{staticClass:"background-responsive"},[_c('p',{staticClass:"name-collaborator-responsive"},[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_c('p',{staticClass:"name-carge"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticClass:"carge"},[_vm._v(_vm._s(item.carge))])],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}]},[_c('banner',{attrs:{"window-size":_vm.windowSize,"links":_vm.links}}),_vm._v(" "),_c('component-our-products',{attrs:{"window-size":_vm.windowSize,"logos-company":_vm.logosCompany}}),_vm._v(" "),_c('component-our-team',{attrs:{"collaborators":_vm.collaborators,"window-size":_vm.windowSize}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.aab1f73a41c56998f05b.js